import React from "react";
import { StyledLabel } from "./Label.styles";

export function Label({
  children,
  required,
  margin,
  gap,
  fontweight,
  ...props
}) {
  return (
    <StyledLabel
      margin={margin}
      gap={gap}
      fontweight={fontweight}
      {...props}
    >
      {children}
      {required && <span>*</span>}
    </StyledLabel>
  );
}
